import React, { useState, useEffect } from "react";
import * as APIModels from "../../models";
import { RecordsService } from "../../services/RecordsService";
import { SubmissionService } from "../../services/SubmissionService";

import Footer from "../../components/shared/Footer";
import MaterialTable from "@material-table/core";
import { useParams } from "react-router-dom";

export default function CaseView() {
    const { attorneyId } = useParams<{ attorneyId?: string }>();
    const { countyId } = useParams<{ countyId?: string }>();
    const { divisionId } = useParams<{ divisionId?: string }>();
    const { ucn } = useParams<{ ucn?: string }>();

    const [courtCase, setCourtCase] = useState(new APIModels.CourtCase());
    const [parties, setParties] = useState([] as APIModels.Party[]);
    const [documents, setDocuments] = useState([] as APIModels.Document[]);

    useEffect(() => {
        RecordsService.getCaseByUcn({
            attorneyId: attorneyId,
            countyId: countyId,
            divsionId: divisionId,
            ucn: ucn,
        }).then(
            (resp) => {
                if (resp) {
                    setCourtCase(resp.data as APIModels.CourtCase);
                    setParties(resp.data?.parties as APIModels.Party[]);

                    //setErrorMessage(resp.errorMessage ?? "");
                } else {
                    // setErrorMessage(resp.errorMessage ?? "");
                }
            },
            (error) => {
                //setSearching(false);
                //setErrorMessage("An error has occurred");
            }
        );

        SubmissionService.getDocumentsByUcn({
            ucn: ucn,
        }).then(
            (resp) => {
                if (resp) {
                    setDocuments(resp.data as APIModels.Document[]);

                    //setErrorMessage(resp.errorMessage ?? "");
                } else {
                    // setErrorMessage(resp.errorMessage ?? "");
                }
            },
            (error) => {
                //setSearching(false);
                //setErrorMessage("An error has occurred");
            }
        );
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Case View</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            My Cases
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Case View
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="tablesaw-bar tablesaw-mode-stack">
                                <table
                                    className="tablesaw table mb-0 tablesaw-stack text-center"
                                    data-tablesaw-mode="stack"
                                    id="table-saw-3859"
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-priority="4"
                                            >
                                                Case Number
                                            </th>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-priority="4"
                                            >
                                                County
                                            </th>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-priority="4"
                                            >
                                                Case Type
                                            </th>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-sortable-default-col=""
                                                data-tablesaw-priority="persist"
                                            >
                                                Status
                                            </th>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-sortable-default-col=""
                                                data-tablesaw-priority="persist"
                                            >
                                                Case Title
                                            </th>
                                            <th
                                                scope="col"
                                                data-tablesaw-sortable-col=""
                                                data-tablesaw-priority="2"
                                            >
                                                UCN
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{courtCase.caseNumber}</td>
                                            <td>{courtCase.county}</td>
                                            <td>{courtCase.caseType}</td>
                                            <td>{courtCase.portalStatus}</td>
                                            <td>{courtCase.caseTitle}</td>
                                            <td>{courtCase.ucn}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <div style={{ maxWidth: "100%" }}>
                                        <MaterialTable
                                            columns={[
                                                {
                                                    title: "Party Type",
                                                    field: "partyType",
                                                },
                                                {
                                                    title: "Party Name",
                                                    field: "name",
                                                },
                                            ]}
                                            data={parties}
                                            title="Parties"
                                            options={{
                                                tableLayout: "auto",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <div style={{ maxWidth: "100%" }}>
                                        <MaterialTable
                                            columns={[
                                                {
                                                    title: "File Name",
                                                    field: "filename",
                                                },
                                                {
                                                    title: "Document Type",
                                                    field: "documentType",
                                                },
                                            ]}
                                            data={documents}
                                            title="Documents"
                                            options={{
                                                tableLayout: "auto",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
